import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e97432b2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e97432b2')) {
      api.createRecord('e97432b2', component.options)
    } else {
      api.reload('e97432b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e97432b2&", function () {
      api.rerender('e97432b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/table/index.vue"
export default component.exports